import { SET_META_DATA } from "../types";

export const setMetaData = (payload: any) => ({
  type: SET_META_DATA,
  payload,
});
